import React from 'react'
import { withStyles } from '@material-ui/core/styles';
import { compose } from 'redux'
import { connect } from 'react-redux'
import NotificationsActiveIcon from '@material-ui/icons/NotificationsActive';
import IconButton from '@material-ui/core/IconButton';
import Badge from '@material-ui/core/Badge';
import Box from '@material-ui/core/Box';
import Popover from '@material-ui/core/Popover';
import PopupState, { bindTrigger, bindPopover } from 'material-ui-popup-state';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import Divider from '@material-ui/core/Divider';
import { firestoreConnect } from 'react-redux-firebase'
import Loader from '../../components/custom/loader'
import { Redirect, Link as RouterLink } from 'react-router-dom'
import { getList } from '../../store/actions/listActions'
import { getCollection } from '../../constant'
import moment from "moment";

const LinkBehavior = React.forwardRef((props, ref) => (
  <RouterLink ref={ref} to="/getting-started/installation/" {...props} />
));

const styles = {
  notiMain: {
    maxWidth: 400,
    minWidth: 250,
    width: '100%'
  },
  row: {
    display: 'flex',
    justifyContent: 'center',
  },
  link: {
    textDecoration: 'none',
    color: "white"
  },
  root: {
    width: '100%',
    maxWidth: 400,
    // backgroundColor: theme.palette.background.paper,
    position: 'relative',
    overflow: 'auto',
    maxHeight: 300,
  },
  listSection: {
    backgroundColor: 'inherit',
  },
  ul: {
    backgroundColor: 'inherit',
    padding: 0,
  },

};

const defaultProps = {
  color: 'secondary',
  children: <NotificationsActiveIcon style={{ color: '#fff' }} />,
};

class Notifications extends React.Component {
  handleListItemClick = (event, selectedIndex, notification) => {
    const { firestore } = this.props;
    firestore.update(
      { collection: getCollection(this.props.profile, 'notifications'), doc: notification.id },
      { read: true },
    )
      .then(() => { }, (err) => { },
      );
  };

  render() {
    const { classes, notifications, auth } = this.props;
    let badge = 0
    notifications && notifications.forEach(n => {
      if (!n.read) badge++
    });

    if (!auth.uid) return <Redirect to='/signin' />

    return (
      <IconButton>
        <PopupState variant="popover" popupId="demo-popup-popover">
          {(popupState) => (
            <div>
              <Badge badgeContent={badge} max={999} {...defaultProps} {...bindTrigger(popupState)} />

              <Popover
                {...bindPopover(popupState)}
                anchorOrigin={{
                  vertical: 'bottom',
                  horizontal: 'center',
                }}
                transformOrigin={{
                  vertical: 'top',
                  horizontal: 'right',
                }}
              >
                <Box p={0} className={classes.notiMain}>
                  <div className={classes.root}>
                    <List component="nav" aria-label="main mailbox folders">

                      {
                        notifications && notifications.length ? notifications.map((notification, index) => {
                          return <React.Fragment key={'notification' + index}>

                            <ListItem
                              button
                              selected={!notification.read}
                              onClick={(event) => { this.handleListItemClick(event, index, notification); popupState.close() }}
                              component={RouterLink} to={
                                notification.taskId ? '/task/' + notification.taskId :
                                  notification.projectId ? '/project/' + notification.projectId : ''
                              }
                            >
                              {/* <ListItemIcon>
                            <InboxIcon />
                          </ListItemIcon> */}
                              <ListItemText primary={notification.title} secondary={moment(notification.createdAt.toDate()).fromNow()} />
                            </ListItem>
                            <Divider />
                          </React.Fragment>
                        })
                          : null
                      }

                    </List>
                  </div>
                </Box>
              </Popover>
            </div>
          )}
        </PopupState>
      </IconButton>
    )
  }
}

const mapDispatchToProps = dispatch => {
  return {
    getList: (listName, con) => dispatch(getList(listName, con))
  }
}

const mapStateToProps = (state) => {

  const notifications = state.firestore.ordered[getCollection(state.firebase.profile, 'notifications')] || [];

  notifications.sort((a, b) => {
    return b.createdAt - a.createdAt;
  });

  return {
    auth: state.firebase.auth,
    notifications,
    profile: state.firebase.profile,
    loading: state.listReducer.loading,
  }
}

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  firestoreConnect((props) => {
    if (props.profile.id)
      return [
        {
          collection: getCollection(props.profile, 'notifications'),
          where: ['to', '==', props.profile.id],
          // orderBy: ['createdAt']
        },
      ]

    else return []
  })
)(withStyles(styles)(Notifications));
